<template>
  <div class="login_container">
    <div class="login_bg"></div> 
    <div class="login">
      <div class="logo_section">
        <img :src="logo_img" class="logo" />
        <div class="logo_text montserrat-subrayada-bold">CloudFarm</div>
      </div>

      <div class="input_section">
        <v-text-field outlined rounded 
        class="mx-auto input_box"
        prepend-inner-icon="mdi-account-circle"
        label="아이디"
        ref="account" 
        v-model="account"
        color="#065488"
      />
      <v-text-field outlined rounded
          class="mx-auto input_box mt-3"
          prepend-inner-icon="mdi-lock" 
          :type="showPassword ? 'text' : 'password'" 
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          label="비밀번호"
          ref="password" 
          v-model="password"
          @click:append="showPassword = !showPassword"
          color="#065488"
      />
      </div>

      <div>
        <v-btn
          id="login" 
          class="rounded-pill mt-5"
          @click.prevent="clickLogin()"
          type="submit">
          로그인
       </v-btn>
      </div>

      <div id="error_login">
        아이디 또는 비밀번호가 잘못 되었습니다. 아이디와 비밀번호를 정확히 입력해 주세요.
      </div>

      <div class="mt-3 bottom-container">
        <v-btn text color="#666666"
          id="sign_up"  
          class="rounded-pill"
          href="/user/joinagree">회원가입
        </v-btn>

        <div>
          <v-icon size="10" color="#005B96">
            mdi-checkbox-blank-circle
          </v-icon>
        </div>

        <v-btn text color="#666666"
          id="find_id"  
          class="rounded-pill"  
          href="/user/findid">
          아이디찾기
        </v-btn>

        <div>
          <v-icon size="10" color="#005B96">
            mdi-checkbox-blank-circle
          </v-icon>
        </div>
        
        <v-btn text color="#666666"
          id="find_password"
          class="rounded-pill"
          href="/user/findpassword">
          비밀번호찾기 
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import dateUtil from "@/utils/custom/dateProperty.js";

  export default {
    name: 'Login',

    data() {
      return {
        logo_img: require("@/assets/logo_simple.svg"),

        account : "",
        password : "",
        showPassword: false
      };
    },
    mounted() {
      this.$refs.account.focus();
    },

    methods : {
      // ...mapMutations(['doLogin']),
      clickLogin() {
        // console.log("login submit");
        let account = this.account;
        let password = this.password;

        if (!account) {
          alert("아이디를 입력하세요.");
          this.$refs.account.focus();
          return;
        }
        if (!password) {
          alert("비밀번호를 입력하세요.");
          this.$refs.password.focus();
          return;
        }

        this.$dispatch("login", {
          session_id: this.getSessionId(account),
          account: account,
          password: password,
        }).then((res) => {
          if (res.result) {
            // 로그인 성공 시 환영메세지 팝업 노출
              // console.log("권한:",this.$getters.userInfo.grade);
            // alert(this.$getters.userName + "님 안녕하세요.");
            // this.$router.push("/monitoring/summary").catch((e) => {
            this.$router.push("/home").catch((e) => {
              console.log(e.message);
            });
          } else {
            document.getElementById("error_login").style.display = 'block';
            // alert('아이디 또는 비밀번호가 잘못 되었습니다. 아이디와 비밀번호를 정확히 입력해 주세요.')
            this.account = "";
            this.password = "";
            this.$refs.account.focus();
            // console.log(res);
          }
        }).catch( (err) => {  // 개별 API 오류 처리 예제
            console.log("LogIn 호출 오류",err);
            alert(err);
            this.$router.push("/user/login");
            }) ;
            // alert("님 안녕하세요.");

      },

      getSessionId(account) {
        let _sessionId = `${this.getNation()}/${this.getPageId()}/${this.getLocalTime()}/${account}////${this.getUtcTime()}`;
        // console.log(_sessionId);
        return _sessionId;
      },
      getNation() {
        let type = navigator.appName;
        let lang = "";
        let nation = "KOR"; // 기본값 한국
        if (type === "Netscape") {
          lang = navigator.language;
        } else {
          lang = navigator.userLanguage.substr(0, 2);
        }

        // TODO: 국가코드 정해달라고 해야됨
        switch (lang) {
          case "zh": // 중국
            nation = "CHN";
            break;
          case "en": // 미국
            nation = "ENG";
            break;
          default:
            break;
        }
        return nation;
      },
      getPageId() {
        // TODO: 화면아이디 지금 다 바뀌어서 다시 정해야될듯
        return "000010";
      },
      getLocalTime() {
        return dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss");
      },
      getUtcTime() {
        // 1. 현재 시간(Locale)
        const curr = new Date();
        // console.log("현재시간(Locale) : " + curr);

        // 2. UTC 시간 계산
        const utc = curr.getTime() + curr.getTimezoneOffset() * 60 * 1000;

        // TODO: 시간 형식 ISO 표준으로 하는게 맞을지 문서에 나온규격대로 짜르는게 맞을지?
        // return new Date(utc).toISOString();
        return dateUtil.format(new Date(utc), "yyyy-MM-dd HH:mm:ss");
      },


    }
  }
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Montserrat+Subrayada:wght@400;700&display=swap');
.montserrat-subrayada-bold {
  font-family: "Montserrat Subrayada", sans-serif;
  font-weight: 700;
  font-style: normal;
}
.container{
  width: 100%;
  padding: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.login_container{
  position: relative; 
  display: flex;
  justify-content: center; 
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  margin-top:-5px;
  margin-left:-87px;
}
.login_bg{
  background-image: url("../../assets/login/login_bg.png");
  background-repeat: no-repeat;
  background-size: cover; 
  width: 100vw; /* 전체 화면 너비 */
  height: 100vh; /* 전체 화면 높이 */
  background-position: center; 
  position: absolute; 
  top: 0; 
  left: 0;
  opacity: 0.2; 
}

.login{
  background-color:white;
  padding:20px;
  border-radius: 40px;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  width:37rem;
  aspect-ratio: 1 / 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.logo{
  width:15rem;
  height:13rem;
}
.logo_text{
  font-size:2rem;
  color:#065488;
  letter-spacing: -1.25px;
  margin-top:-55px !important;
}
#error_login{
  font-size:0.8rem;
  margin-top:10px;
  color:#ff5353;
  display:none;
}
.input_section{
  margin-top:30px;
}
.input_box{
  min-width:20rem;
  height:55px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
}
#login{
  min-width:20rem !important; 
  height:55px !important;
  background-color: #065488 !important;
  color:white !important;
  font-size:1.2rem !important;
  letter-spacing: -1px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}
.bottom-container{
  display:flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 768px) {
  html, body {
    overflow: hidden;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .login_container {
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    margin-left:0 !important;
  }

  .login_bg {
    width: 100%;
    height: 100%;
  }

  .login {
    width: 90vw; 
  }
}
</style>
